<template>
  <div class="app-container">
    <navigation title="书刊推介"></navigation>
    <div class="main">
      <div class="tab">
        <van-tabs :ellipsis="false" title-inactive-color="#333" line-height="2px" @click="tabClick" class="first-tab">
          <van-tab v-for="(tab,index) in tabList" :key='tab.id' :title="tab.name" :name='tab.id'>
            <van-tabs v-model="secActive[index]"  v-if="tab.childrenList && tab.childrenList.length>0" class="second-tab" @click="secClick">
              <van-tab v-for="secondChild in tab.childrenList" :key='secondChild.id' :title="secondChild.name" :name='secondChild.id'>
                <van-list
                  v-model="secLoading"
                  :finished="secFinished"
                  finished-text="没有更多了"
                >
                  <div v-for="item in secList" :key="item.title" class="list-div">
                    <p class="childrenTab" v-if="item.isChildren && secondChild.childrenList !==undefined && secondChild.childrenList.length>0">{{ item.bookCategory.name }}</p>
                    <van-cell :title="item.title">
                      <template #label>
                        <p class="message">出版社：<span>{{ item.press }}</span></p>
                        <p class="message">书著者：<span>{{ item.author }}</span></p>
                        <p class="message">出版年：<span>{{ item.pubDate }}</span></p>
                        <p class="askNumber">索书号：<span>{{ item.askNumber }}</span></p>
                      </template>
                      <template #icon>
                        <img :src="item.coverPath" alt="" class="list-img">
                      </template>
                    </van-cell>
                  </div>
                </van-list>
              </van-tab>
            </van-tabs>
            <van-list
              v-else
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div v-for="item in list" :key="item.title" class="list-div">
                <van-cell :title="item.title">
                  <template #label>
                    <p class="message">出版社：<span>{{ item.press }}</span></p>
                    <p class="message">书著者：<span>{{ item.author }}</span></p>
                    <p class="message">出版年：<span>{{ item.pubDate }}</span></p>
                    <p class="askNumber">索书号：<span>{{ item.askNumber }}</span></p>
                  </template>
                  <template #icon>
                    <img :src="item.coverPath" alt="" class="list-img">
                  </template>
                </van-cell>
              </div>
            </van-list>
          </van-tab>
        </van-tabs>
        <page-share :show="showShare" @show='getShow' title="书刊推介"></page-share>
      </div>
    </div>
    <scroll></scroll>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, NavBar, Cell, CellGroup, Tab, Tabs, ShareSheet } from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import pageShare from '../../components/pageShare'
import version from '../../components/version'
import scroll from '../../components/scroll'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup).use(Tab).use(Tabs).use(ShareSheet)

export default {
  name: 'bookRecommend',
  components: {navigation, pageShare, version, scroll},
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      showShare: false,
      tabList: [{
        name: '全部',
        id: ''
      }],
      params: {
        pageNum: '1',
        pageSize: '10'
      },
      secLoading: false,
      secFinished: false,
      secList:[],
      secParams: {
        pageNum: '1',
        pageSize: '10',
        catId:''
      },
      bookCategoryName: '',
      secActive:[],
      index:''
    }
  },
  created () {
    // 获取分类
    this.getTab()
  },
  methods: {
    getShow (msg) {
      this.showShare = msg
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    onLoad (id) {
      if (id) {
        this.params.catId = '' + id + ''
      }
      request('get', '/nlc-web/api/bookRecommend', this.params).then(res => {
        console.log('列表', res)
        for (let i = 0; i < res.data.content.length; i++) {
          res.data.content[i].pubDate = res.data.content[i].pubDate.split('-')[0]
          this.list.push(res.data.content[i])
        }
        // 加载状态结束
        this.loading = false
        if (res.data.totalElements === this.list.length) {
          this.finished = true
        }
      })
      this.params.pageNum++
    },
    secOnLoad  (id) {
      this.secParams.catId = '' + id[this.index] + ''
      request('get', '/nlc-web/api/bookRecommend', this.secParams).then(res => {
        console.log('二级列表', res)
        for (let i = 0; i < res.data.content.length; i++) {
          res.data.content[i].pubDate = res.data.content[i].pubDate.split('-')[0]
          if (!this.bookCategoryName) {
            this.bookCategoryName = res.data.content[i].bookCategory.name
            res.data.content[i].isChildren = true
          }
          if (this.bookCategoryName != res.data.content[i].bookCategory.name) {
            this.bookCategoryName = res.data.content[i].bookCategory.name
            res.data.content[i].isChildren = true
          }
          this.secList.push(res.data.content[i])
        }
        console.log('this.secList',this.secList)
        // 加载状态结束
        this.secLoading = false
        if (res.data.totalElements === this.secList.length) {
          this.secFinished = true
        }
      })
      this.secParams.pageNum++
    },
    onShare () {
      event.stopPropagation()
      this.showShare = true
    },
    // 获取分类
    getTab () {
      request('get', '/nlc-web/api/bookRecommend/category').then(res => {
        console.log('书刊分类', res)
        for (var i = 0; i < res.data.length; i++) {
          this.tabList.push(res.data[i])
        }
      })
    },
    tabClick (name) {
      this.bookCategoryName=''
      this.params.pageNum = '1'
      this.list = []
      this.finished = false
      this.tabList.forEach(item=>{
        if(item.id){
          this.index = this.tabList.findIndex( item => item.id === name)
        }
      })
      if (!name) {
        delete this.params.catId
        this.onLoad()
      } else if(this.tabList[this.index].childrenList.length>0){
        this.secActive[this.index] = Number(this.tabList[this.index].childrenList[0].id)
        this.secParams.pageNum = '1'
        this.secList = []
        this.secFinished = false
        this.secOnLoad(this.secActive)
      } else {
        this.onLoad(name)
      }
    },
    secClick () {
      this.secParams.pageNum = '1'
      this.secList = []
      this.secFinished = false
      this.secOnLoad(this.secActive)
    }
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  position:absolute;
  left:0;
  top:0;
  min-height:100%
}
.main{
  width:6.94rem;
  margin:1.16rem .28rem 0 .28rem;
  background:#fff;
  border-radius:8px;
  padding-top:.1rem;
}
.list-img{
  width:1.7rem;
  height:2.4rem;
  margin-right:.26rem;
  box-shadow: 6px 4px 10px -6px #000;
}
.van-cell__label{
  line-height:.15rem;
}
.message{
  width: 3rem;
  height: .4rem;
  line-height: .4rem;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  margin:0;
}
.askNumber{
  width: 3rem;
  line-height: .4rem;
  margin:0;
}
.childrenTab{
  height:.52rem;
  line-height:.52rem;
  font-size:.32rem;
  color:#47494C;
  margin:.3rem 0 0 .16rem;
  padding-left:.12rem;
  background-size:20% 100%;
  font-family: SourceHanSerifCN-Bold;
}
.list-div{
  position:relative;
}
.list-div::after{
  border-bottom: 1px solid #B3BBC3;
  position: absolute;
  box-sizing: border-box;
  content: ' ';
  pointer-events: none;
  right: 16px;
  bottom: 0;
  left: 16px;
  transform: scaleY(.5);
}
.van-cell__title{
  line-height:.35rem;
}
>>>.van-tabs__wrap{
  height:.65rem;
  margin: .15rem;
  border-bottom: 1px solid #DCE5ED;
}
.first-tab >>>.van-tab--active .van-tab__text{
  font-size:.36rem;
  line-height: .36rem;
}
.second-tab >>>.van-tab--active .van-tab__text{
  font-size:.32rem;
  line-height: .32rem;
}
.second-tab >>>.van-tabs__line{
  background:#fff !important;
}
>>>.van-tab__text{
  font-family: SourceHanSerifCN-Regular
}
.van-cell{
  padding:.2rem .3rem;
}
</style>



// WEBPACK FOOTER //
// src/view/bookRecommend/index.vue